import { IconSvgElement } from "@hugeicons/react";
import { useUnreadConversationsCount } from "views/inbox/api/use-unread-conversations-count";
import { formatNavBadgeCount } from "../use-nav-item-counts";
import { NavLink } from "./NavLink";

interface InboxNavLinkProps {
  name: string;
  to: string;
  Icon: IconSvgElement;
}

export const InboxNavLink = ({ name, to, Icon }: InboxNavLinkProps) => {
  const { unreadConversations } = useUnreadConversationsCount();

  return (
    <NavLink
      to={to}
      HugeIcon={Icon}
      indicator={
        unreadConversations > 0
          ? formatNavBadgeCount(unreadConversations)
          : undefined
      }
    >
      {name}
    </NavLink>
  );
};
